import React from 'react';
import { useTranslate } from '../../../../../hooks';
import { useClientSideSearch } from '../../hooks';

import { Button, SearchInput } from '../../../../../components';
import ListItems from './ListItems';
import { useDebounce } from '../../../../../hooks';

function SuggestionList({
  suggetionsList,
  handleSuggestionSelect,
  selectedCount,
  suggetionCount,
  hideButton,
  onAddAll,
}) {
  const { translate } = useTranslate();
  const [search, setSearch] = useDebounce('');
  const { filteredList } = useClientSideSearch({
    list: suggetionsList,
    key: 'name',
    search: search,
  });
  return (
    <div
      className={`rounded-md !border-border !border-2 p-3 w-[100%] add-configuration-section-card pb-0`}
    >
      <div className="flex justify-between">
        <div className="flex flex-col gap-2">
          <p className="text-primary text-sm tracking-[0.6px] font-semibold">
            {translate('Suggetion for you')}
          </p>
          <p className="text-xs text-text tracking-[0.6px]">
            {selectedCount}/{suggetionCount} {translate('Selected')}
          </p>
        </div>
        {!hideButton && (
          <Button
            className={
              'bulk-import-btn !border-solid gap-x-1 shrink-0 px-2 pr-3 rounded-[4px] h-7'
            }
            disabledClassName={
              'disabled-btn !border-solid gap-x-1 shrink-0 px-2 pr-3 rounded-[4px] h-7'
            }
            disabled={selectedCount === suggetionCount}
            onClick={onAddAll}
          >
            <i className="las la-plus !text-[14px]"></i>
            <p className="!text-xs">{translate('Add all')}</p>
          </Button>
        )}
      </div>
      <SearchInput
        containerClassName={'w-full h-[56px] mt-[4px]'}
        className={'w-full py-2 h-10 border-gray-800 border-opacity-25 mt-2'}
        onChange={(e) => setSearch?.(e.target.value)}
      />
      <div className="overflow-y-auto flex flex-col max-h-[305px] mt-3 gap-2 mb-3 px-1">
        {filteredList?.map((suggetion, index) => (
          <ListItems
            key={suggetion?.name + index}
            value={suggetion}
            handleClick={() => handleSuggestionSelect(suggetion, index)}
          />
        ))}
      </div>
    </div>
  );
}

export default SuggestionList;
